const HomeTabItemFill = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="23"
            viewBox="0 0 21 23"
            fill="none"
            {...props}
        >
            <path
                d="M19.0644 8.00832C15.5035 3.75792 11.0296 0.344716 10.2626 0.344716C9.49567 0.344716 6.17219 3.86832 5.40523 4.75152C5.22262 4.96312 5.03088 5.21152 5.10393 5.47832C5.17697 5.77272 5.53306 5.91992 5.82523 5.84632C6.10827 5.77272 6.31827 5.49672 6.41871 5.21152C6.51001 4.92632 6.51001 4.62272 6.51001 4.32832C6.51001 3.78552 6.88436 0.657516 6.40045 0.363116C6.24523 0.280316 2.98567 0.390716 2.92175 0.455116C2.84871 0.528716 2.84871 4.53992 2.97653 6.65592C3.01306 7.37352 0.538709 9.39752 0.401752 9.88512C0.301317 10.2347 0.684796 18.6987 0.867404 22.3327C0.867404 22.4891 7.3774 22.4155 7.44132 22.3511C7.50523 22.2867 7.4961 18.8919 7.24958 16.5827C7.24958 16.4815 7.22219 16.3711 7.27697 16.2791C7.35914 16.1135 7.59653 16.0951 7.78827 16.0951C9.61436 16.1135 11.4313 16.2055 13.2391 16.3619C13.367 16.3619 13.5131 16.3895 13.6044 16.4815C13.6774 16.5551 12.7096 22.1671 13.1296 22.3971C13.5496 22.6271 19.7491 22.6547 20.087 22.3327C20.1965 22.2315 20.7626 10.4003 20.6074 10.2531C20.5526 10.0323 19.0826 7.99912 19.0826 7.99912"
                fill="#686058"
            />
        </svg>
    )
}

export default HomeTabItemFill
